import {ChangeDetectionStrategy, Component} from '@angular/core';
import {
  LotteriesDialogContentComponent,
  LotteryDialogListItemDirective
} from "../lotteries-dialog-content/lotteries-dialog-content.component";
import {LotteryListItemComponent} from "../../../../components/lottery-list-item/lottery-list-item.component";
import {NotificationPage} from "../../multi-page-notification/multi-page-notification.component";
import {LotteryNumberReceivedNotificationDto} from "homey-housing-lottery-app-dto";

@Component({
  selector: 'homey-lottery-number-received-applications-dialog-content',
    imports: [
        LotteriesDialogContentComponent,
        LotteryDialogListItemDirective,
        LotteryListItemComponent
    ],
  templateUrl: './lottery-number-received-applications-dialog-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LotteryNumberReceivedApplicationsDialogContentComponent extends NotificationPage<LotteryNumberReceivedNotificationDto> {
}
